<div class="list-page vo-profile">
    <lokos-page-header [label]="headerLeader" [breadcrumbs]="breadcrumbs">
    </lokos-page-header>

    <lokos-card> </lokos-card>
</div>

<div class="resolution-wrapper" id="printAbleArea">
    <div class="resolution-card">
        <!-- Header -->
        <div class="resolution-header">
            <div class="header-logo header-logo--left">
                <img
                    src="assets/images/aajeevika-logo.svg"
                    alt="NRLM Logo"
                    class="logo-img"
                />
            </div>
            <div class="header-center">
                <h1 class="header-title">DAY-NRLM</h1>
                <p class="header-subtitle">
                    {{ 'resolutionCopyCommunityBasedOrg' | translate }}
                </p>
                <p class="header-subtitle">
                    {{ 'resolutionCopyUnderNRLM' | translate }}
                </p>
            </div>
            <div class="header-logo header-logo--right">
                <img
                    src="assets/images/lokOsLogo.svg"
                    alt="Mission Logo"
                    class="logo-img"
                />
            </div>
        </div>

        <!-- Date -->
        <div class="date-row">
            <span class="date-label">{{ 'date' | translate }} :</span>
            <span class="date-value">{{ todayData | date: 'dd-MM-yyyy' }}</span>
        </div>

        <!-- Intro paragraph -->
        <p class="intro-para">
            {{ 'resolutionCopyMeetingLocation' | translate }}

            @if (
                shgDesigPresident && shgDesigPresident[0]?.member_relation_name
            ) {
                <span>
                    Mrs.<span class="underline-field"
                        >{{
                            shgDesigPresident &&
                                shgDesigPresident[0]?.member_relation_name
                        }}
                    </span>
                    w/o of
                </span>
            }
            @if (shgDesigPresident && shgDesigPresident[0]?.member_name) {
                <span>
                    <span class="underline-field">
                        Mr.{{ shgDesigPresident[0]?.member_name }},</span
                    ></span
                >
            }

            {{ 'inVillage' | translate }}
            <span class="underline-field">{{ villageName }}</span
            >, {{ 'block' | translate }}
            <span class="underline-field">{{ blockName }}</span
            >, {{ 'district' | translate }}
            <span class="underline-field">{{ distName }}</span
            >.
        </p>

        <p class="intro-para">
            <strong>10</strong> {{ 'resolutionCopyIntro' | translate }}:
        </p>

        <!-- SHG Name -->
        <div class="shg-field-row shg-name-row">
            <div class="field-box full-width">
                <span class="field-label">{{ 'shgName' | translate }}:</span>
                <span class="field-value">{{ contName }}</span>
            </div>
        </div>

        <!-- President -->
        @if (shgDesigPresident && shgDesigPresident[0]?.member_name) {
            <div class="shg-field-row">
                <div class="field-box">
                    <span class="field-label"
                        >{{ 'shgPresidentName' | translate }}:</span
                    >
                    <span class="field-value">{{
                        shgDesigPresident[0]?.member_name
                    }}</span>
                </div>
                <div class="field-box">
                    @if (
                        shgDesigPresident &&
                        shgDesigPresident[0]?.member_relation_name
                    ) {
                        <span class="field-label">Wife Of:</span>
                        <span class="field-value"
                            >{{ shgDesigPresident[0]?.member_relation_name }}
                        </span>
                    }
                </div>
            </div>
        }

        <!-- Secretary -->
        @if (shgDesigSecretary && shgDesigSecretary[0]?.member_name) {
            <div class="shg-field-row">
                <div class="field-box">
                    <span class="field-label"
                        >{{ 'shgSecretaryName' | translate }}:</span
                    >
                    <span class="field-value">{{
                        shgDesigSecretary[0]?.member_name
                    }}</span>
                </div>
                <div class="field-box">
                    @if (
                        shgDesigSecretary &&
                        shgDesigSecretary[0]?.member_relation_name
                    ) {
                        <span class="field-label">Wife Of:</span>
                        <span class="field-value">{{
                            shgDesigSecretary[0]?.member_relation_name
                        }}</span>
                    }
                </div>
            </div>
        }

        <!-- Treasurer -->
        @if (shgDesigTreasurer && shgDesigTreasurer[0]?.member_name) {
            <div class="shg-field-row">
                <div class="field-box">
                    <span class="field-label"
                        >{{ 'shgTreasurerName' | translate }}:</span
                    >
                    <span class="field-value">{{
                        shgDesigTreasurer[0]?.member_name
                    }}</span>
                </div>
                <div class="field-box">
                    @if (
                        shgDesigTreasurer &&
                        shgDesigTreasurer[0]?.member_relation_name
                    ) {
                        <span class="field-label"
                            >{{ 'wifeOf' | translate }}:</span
                        >
                        <span class="field-value">{{
                            shgDesigTreasurer[0]?.member_relation_name
                        }}</span>
                    }
                </div>
            </div>
        }

        <!-- Bullet Points -->
        <ul class="resolution-bullets">
            <li>
                {{ 'shgSavingBankName' | translate }}:
                {{ ShgBankList[0]?.bank_name }},
                <span class="underline-field">{{
                    ShgBankList[0]?.bank_branch_name || BankBranchName
                }}</span>
                {{ 'branch' | translate }}.
            </li>
            <li>
                {{ 'eachAttendeeHasAgreed1' | translate }}
                <span class="underline-field bold-field">₹1000</span>
                {{ 'eachAttendeeHasAgreed2' | translate }}
            </li>
            @if (ShgProfileDetail?.meeting_frequency) {
                <li>
                    @if (ShgProfileDetail?.meeting_frequency === 1) {
                        {{ 'shgRegularMeetingDay' | translate }}:
                        <span class="underline-field bold-field">{{
                            getValueForLookup(34, ShgProfileDetail?.meeting_on)
                        }}</span>
                        {{ 'shgWeek' | translate }}.
                    }
                    @if (ShgProfileDetail?.meeting_frequency === 2) {
                        {{ 'shgRegularMeetingDay' | translate }}:
                        <span class="underline-field bold-field">{{
                            getValueForLookup(34, ShgProfileDetail?.meeting_on)
                        }}</span
                        >, {{ 'shgWeekNumber' | translate }}:
                        <span class="underline-field bold-field">
                            {{
                                getValueForLookup(
                                    16,
                                    ShgProfileDetail?.meeting_frequency_value
                                )
                            }}</span
                        >
                        {{ 'shgMonth' | translate }}.
                    }
                    @if (ShgProfileDetail?.meeting_frequency === 3) {
                        {{ 'shgRegularMeetingDay' | translate }}:
                        <span class="underline-field bold-field">{{
                            getValueForLookup(34, ShgProfileDetail?.meeting_on)
                        }}</span
                        >, {{ 'shgWeekNumber' | translate }}:
                        <span class="underline-field bold-field">
                            {{
                                getValueForLookup(
                                    15,
                                    ShgProfileDetail?.meeting_frequency_value
                                )
                            }}
                        </span>
                        {{ 'shgMonth' | translate }}.
                    }
                </li>
            }
        </ul>

        <!-- Group Guidelines -->
        <div class="guidelines-section">
            <h3 class="guidelines-title">{{ 'shgGuidelines' | translate }}:</h3>
            <ol class="guidelines-list">
                <li *ngFor="let guideline of guidelines">{{ guideline }}</li>
            </ol>
        </div>

        <!-- Resolution Passed Statement -->
        <p class="resolution-statement">
            {{ 'shgResolutionPassedStatement' | translate }}
        </p>

        <!-- Signatories -->
        <div class="signatories-row">
            @if (shgDesigPresident && shgDesigPresident[0]?.member_name) {
                <div class="signatory-block">
                    <p class="otp-label">OTP Verified by</p>
                    <div class="signature-tick">
                        <img
                            src="../../../../../assets/images/verify.svg"
                            alt="OTP Verified"
                            class="tick-img"
                        />
                    </div>
                    <p class="signatory-name">
                        {{ 'name' | translate }}:
                        <strong>{{ shgDesigPresident[0]?.member_name }}</strong>
                    </p>
                    <p class="signatory-designation">
                        {{ 'designation' | translate }}: SHG President
                    </p>
                </div>
            }
            @if (shgDesigSecretary && shgDesigSecretary[0]?.member_name) {
                <div class="signatory-block">
                    <p class="otp-label">OTP Verified by</p>
                    <div class="signature-tick">
                        <img
                            src="../../../../../assets/images/verify.svg"
                            alt="OTP Verified"
                            class="tick-img"
                        />
                    </div>
                    <p class="signatory-name">
                        {{ 'name' | translate }}:
                        <strong>{{ shgDesigSecretary[0]?.member_name }}</strong>
                    </p>
                    <p class="signatory-designation">
                        {{ 'designation' | translate }}: SHG Secretary
                    </p>
                </div>
            }
            @if (shgDesigTreasurer && shgDesigTreasurer[0]?.member_name) {
                <div class="signatory-block">
                    <p class="otp-label">OTP Verified by</p>
                    <div class="signature-tick">
                        <img
                            src="../../../../../assets/images/verify.svg"
                            alt="OTP Verified"
                            class="tick-img"
                        />
                    </div>
                    <p class="signatory-name">
                        {{ 'name' | translate }}:
                        <strong>{{ shgDesigTreasurer[0]?.member_name }}</strong>
                    </p>
                    <p class="signatory-designation">
                        {{ 'designation' | translate }}: SHG Treasurer
                    </p>
                </div>
            }
        </div>

        <!-- Annexure-I: Member List -->
        @for (data of splitShgMembersListsData; track data; let i = $index) {
            <div class="annexure-section">
                <h3 class="annexure-title">Annexure-I: SHG Member Details</h3>

                <!-- Table Header -->
                <div class="member-table">
                    <div class="member-row member-row--header">
                        <div class="member-cell member-cell--sno">
                            {{ 'serial_num' | translate }}
                        </div>
                        <div class="member-cell member-cell--name">
                            {{ 'shgMemberName' | translate }}
                        </div>
                        <div class="member-cell member-cell--relative">
                            {{ 'relativeName' | translate }}
                        </div>
                        <div class="member-cell member-cell--class">
                            {{ 'socialClass' | translate }}
                        </div>
                        <div class="member-cell member-cell--age">
                            {{ 'age' | translate }}
                        </div>
                        <div class="member-cell member-cell--designation">
                            {{ 'designation' | translate }}
                        </div>
                        <div class="member-cell member-cell--signature">
                            {{ 'signatureThumbprint' | translate }}
                        </div>
                    </div>

                    <!-- Member Rows -->
                    <div
                        class="member-row"
                        *ngFor="let member of data; track member"
                        [class.member-row--even]="i % 2 === 1"
                    >
                        <div class="member-cell member-cell--sno">
                            {{ findIndex(member?.member_code) + 1 }}
                        </div>
                        <div class="member-cell member-cell--name">
                            {{ member?.member_name }}
                        </div>
                        <div class="member-cell member-cell--relative">
                            {{
                                member?.relation_name === ''
                                    ? '-'
                                    : member?.relation_name
                            }}
                        </div>
                        <div class="member-cell member-cell--class">
                            {{ member?.social_class }}
                        </div>
                        <div class="member-cell member-cell--age">
                            {{ member?.age }}
                        </div>
                        <div class="member-cell member-cell--designation">
                            {{ member?.mem_designation }}
                        </div>
                        <div class="member-cell member-cell--signature"></div>
                    </div>
                </div>
            </div>
        }

        <!-- Footer note -->
        <p class="footer-note">
            {{ 'footerNote' | translate }}
        </p>

        <!-- Print Button -->
        <div class="print-bar">
            <lokos-button
                [label]="'print'"
                [type]="'primary'"
                (afterClick)="printDocument()"
            />
        </div>
    </div>
</div>
